import Axios from 'axios';

Axios.defaults.baseURL = 'https://api.reviewuss.com/api';
// Axios.defaults.baseURL = 'http://127.0.0.1:8000/api';
export const axiosInstance = Axios.create({});